import {numbers} from 'motivate-vue-util/dist/lib/filters'
import Vue from 'vue';
const _ = require('lodash')
_.forEach(numbers, (filter, key) => {
  Vue.filter(key, filter)
});
